<style lang="less" scoped>
/deep/ .el-form--label-top .el-form-item__label {
  padding: 0;
}
/deep/ .el-form-item {
  margin-bottom: 12px;
}
/deep/ .form .el-row:last-child .el-form-item {
  margin-bottom: 0px;
}
/deep/ .el-select,
/deep/ .el-input,
/deep/ .el-cascader,
/deep/.el-date-editor,
/deep/.el-input-number {
  width: 100%;
}

/deep/ .el-form-item__label {
  padding: 0;
}
.chinese-box{
  color: #222327;
  font-weight: 400;
  letter-spacing: 2px;
  /deep/ span{
    color: #F56C6C;
    font-weight: bold;
    vertical-align: baseline;
  }
}
</style>

<template>
  <el-row v-for="(row, key) in createLayout" :key="key" :gutter="48">
    <el-col v-for="col in row" :key="col.id" :span="col.span">
      <!-- 自定义插槽 -->
      <template v-if="col.slot != undefined && col.slot != ''">
        <slot :name="col.slot" :source="source" :model="modleData" :col="col" />
      </template>

      <el-form-item v-if="!col.slot" :label="col.label" :prop="col.field">
        <template v-if="col.type == 'el-input'">
            <el-input v-model="modleData[col.field]" :disabled="col.disabled || disabled" :placeholder="col.placeholder" clearable v-bind="col.bind"></el-input>
        </template>
        <template v-if="col.type == 'el-autocomplete'">
            <el-autocomplete v-model="modleData[col.field]" style="width: 100%" :placeholder="col.placeholder" :value-key="col.field" :disabled="col.disabled || disabled" clearable v-bind="col.bind" :fetch-suggestions="((queryString,cb)=>{querySearch(queryString,cb,col)})" @select="((item)=>{
                $emit('handleChange', {
                  field: col.field,
                  data:modleData[col.field],
                  itemData: item
                })
              })"></el-autocomplete>
        </template>
        <template v-if="col.type == 'el-input-number'">
          <el-input-number v-model="modleData[col.field]" style="width: 100%" :precision="2" :disabled="col.disabled || disabled" :placeholder="col.placeholder" v-bind="col.bind"></el-input-number>
        </template>
        <template v-else-if="col.type == 'el-select'">
            <el-select v-model="modleData[col.field]" :placeholder="col.placeholder" :disabled="col.disabled || disabled" filterable clearable v-bind="col.bind" @change="
                $emit('handleChange', {
                  field: col.field,
                  data:modleData[col.field],
                })
              ">
              <el-option v-for="item in source[col.field] || []" :key="item[col.bind.key]" :label="item[col.bind.label]" :value="item[col.bind.value]">
              </el-option>
            </el-select>
        </template>
        <template v-else-if="col.type == 'el-cascader'">
          <el-cascader v-model="modleData[col.field]" :placeholder="col.placeholder" :disabled="col.disabled || disabled" clearable :options="source[col.field] || []" v-bind="col.bind" @change="
              $emit('handleChange', {
                field: col.field,
                data:modleData[col.field],
              })
            ">
          </el-cascader>
        </template>
        <template v-else-if="col.type == 'el-date-picker'">
          <el-date-picker v-model="modleData[col.field]" format="YYYY 年 MM 月 DD 日" :disabled="col.disabled || disabled" :placeholder="col.placeholder" clearable v-bind="col.bind" @change="
              handleChange({
                value: modleData[col.field],
                type: col.type,
                field: col.field,
              });
              $emit('handleChange', {
                field: col.field,
              });
            ">
          </el-date-picker>
        </template>
        <template v-else-if="col.type == 'el-double-date-picker'">
          <el-date-picker v-model="modleData[col.field]" format="YYYY 年 MM 月 DD 日" :placeholder="col.placeholder" :disabled="col.disabled || disabled" clearable type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="
              handleChange({
                value: modleData[col.field],
                type: col.type,
                field: col.field,
                extend: col.extend,
              });
              $emit('handleChange', {
                field: col.field,
              });
            ">
          </el-date-picker>
        </template>
        <template v-else-if="col.type == 'el-cash-input-number'">
          <el-input-number 
            :disabled="col.disabled || disabled"
            v-model="modleData[col.field]" 
            style="width: 100%" 
            :precision="2" 
            :placeholder="col.placeholder" 
            v-bind="col.bind" 
            @keyup="inputFn(col,$event)"
            @blur="
              $emit('handleChange', {
                field: col.field,
                data:modleData[col.field],
              })
            "
           ></el-input-number>
          <div class="chinese-box" v-html="col.chineseText"></div>
        </template>
        <template v-else-if="col.type == 'upload'">
              <sz-upload
                :listType="'picture-card'"
                :disabled="col.disabled || disabled"
                :accept="'.jpg,.png,.jpeg,.pdf'"
                :file-lists="modleData[col.field]"
                @getResult="
                  (data) => {
                    modleData[col.field] = data;
                  }
                "
              ></sz-upload>
        </template>
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script lang="ts">
import {
  getCurrentInstance,
  defineComponent,
  PropType,
  computed,
  Ref,
  ref,
  inject,
  reactive,
  watch,
  toRefs,
} from "vue";
import { dayFunc } from "@/hooks/factoryFunc";
import utils from "@/utils/utils";
import { layout } from "@/views/engineering/project/info/layout";
export default defineComponent({
  emits: ["handleChange"],
  props: {
    /**
     * @param {Array} layout 表单布局
     */
    layout: {
      type: Array as PropType<any[]>,
      default: (): any => [],
      required: true,
    },

    /**
     * @param {Object} 当前表单的值
     */
    modelValue: {
      type: Object as PropType<any>,
      default: (): any => {
        return {};
      },
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    let { proxy }: any = getCurrentInstance();
    const propsData: any = reactive(props);
    const modleData = propsData.modelValue;
    const filter: any = inject("filter");
    const source: any = inject("source");

    const chineseText:any = reactive({
      value:'',
    });
    /**
     * @param componentsMap 组件默认配置表
     */
    const componentsMap = new Map([
      [
        "el-input",
        {
          placeholder: "请输入",
          span: 8,
        },
      ],
      [
        "el-autocomplete",
        {
          placeholder: "请输入",
          span: 8,
        },
      ],
      [
        "el-select",
        {
          placeholder: "请选择",
          span: 8,
          bind: {
            key: "key",
            label: "label",
            value: "value",
          },
        },
      ],
      [
        "el-cascader",
        {
          placeholder: "请选择",
          span: 8,
        },
      ],
      [
        "el-date-picker",
        {
          placeholder: "请选择日期",
          span: 8,
          bind: {
            type: "date",
          },
        },
      ],
      [
        "el-input-number",
        {
          placeholder: "请输入",
          span: 8,
          bind: {
            min: "min",
            max: "max",
            // step: "step",
          },
        },
      ],
      [
        "el-double-date-picker",
        {
          placeholder: "请选择日期",
          span: 8,
          bind: {
            type: "date",
          },
        },
      ],
      [
        "el-cash-input-number",
        {
          placeholder: "请输入金额",
          span: 8,
        },
      ],
      [
        "upload",
        {
          placeholder: "请上传图片",
          span: 8,
        },
      ]
    ]);

    /**
     * @method createLayout 生成表单布局
     */
    // watch([filter,layout], () => {}, {
    //    deep: true,
    // });

    const createLayout = computed((): any => {
      /**
       * @param MAX_GRID    默认 最大栅格数
       * @param sum         默认 总计
       * @param count       默认 计数
       */
      const layoutMulti: any = [];
      const MAX_GRID = 24;
      let index = 0;

      // 1、过滤掉不在 组件信息配置中的列表
      // 2、填充span 数据
      // 3、生成一个id优化diff算法
      const layout: any[] = propsData.layout.filter(
        (formItem: any, index: number) => {
          let field = formItem.field;
          let formItemType = formItem.type;
          let isExist =
            componentsMap.has(formItemType) &&
            Boolean(field) &&
            !filter.includes(field);

          // 优化diff
          formItem.id = Number(
            Math.random().toString().substr(3, 8) + Date.now()
          ).toString(8);

          if(formItem.type === 'el-cash-input-number'){
            formItem.chineseText = utils.convertCurrency(modleData[formItem.field]) || "";
          }

          if (isExist) {
            let components: any = componentsMap.get(formItemType);
            //    合并bind
            formItem.bind = {
              ...(components.bind || {}),
              ...(formItem.bind || {}),
            };

            //    合并属性配置
            !formItem.span ? (formItem.span = components.span) : false;

            !formItem.placeholder
              ? (formItem.placeholder = components.placeholder)
              : false;

            return true;
          } else if (formItem.slot && !filter.includes(formItem.slot)) {
            // 如果是使用自定义卡槽

            !formItem.span ? (formItem.span = 8) : false;
            return true;
          } else {
            console.warn(
              `props---> layout[${index}] 缺省 field 字段,或者字段值为空!。`
            );
            return false;
          }
        }
      );

      // 转换成二维数组
      for (let element of layout) {
        if (layoutMulti[index]) {
          const sum = layoutMulti[index]
            .map((el: any) => el.span)
            .reduce((sum: number, nex: number) => sum + nex);

          if (sum >= MAX_GRID) {
            index++;
            layoutMulti.push([element]);
          } else {
            layoutMulti[layoutMulti.length - 1].push(element);
          }
        } else {
          layoutMulti.push([element]);
        }
      }
      return layoutMulti;
    });
    const { dayjs } = dayFunc();

    const handleChange = ({ field, type, value, extend }: any) => {
      switch (type) {
        case "el-date-picker": {
          modleData[field] = value === null?'':dayjs(value).format("YYYY-MM-DD");
          return;
        }
        case "el-double-date-picker": {
          if (value && value.length == 2) {
            modleData[extend[0]] = dayjs(value[0]).format("YYYY-MM-DD");
            modleData[extend[1]] = dayjs(value[1]).format("YYYY-MM-DD");
          } else {
            modleData[extend[0]] = "";
            modleData[extend[1]] = "";
            return;
          }
        }
      }
    };

    const inputFn = (col:any,e:any)=>{
      col.chineseText = utils.convertCurrency(parseFloat((e.target.value)).toFixed(2));
	    proxy.$forceUpdate();
    }

    const querySearch = (queryString: string, cb: any, col: any)=>{
      let sourceData = JSON.parse(JSON.stringify(source[col.field]));
      const results = queryString
        ? sourceData.filter(createFilter(queryString,col.field))
        : sourceData
      cb(results)
    }

    const createFilter = (queryString: string, paramsName: string) => {
      return (restaurant: any) => {
        return (
          restaurant[paramsName].indexOf(queryString) !== -1
        )
      }
    }

    return {
      source,
      createLayout,
      modleData,
      filter,
      handleChange,
      inputFn,
      querySearch,
    };
  },

  /****************************************************************
   *
   *
   *
   ***************************************************************/
});
</script>